import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "Stock Alert Report", -1)
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_7 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-col" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-file-excel",
              class: "p-button-success px-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dt.exportCSV()))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          value: _ctx.rList,
          lazy: true,
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
          resizableColumns: true,
          loading: _ctx.loading,
          autoLayout: true,
          scrollHeight: "70vh",
          responsiveLayout: "scroll",
          scrollable: true,
          ref: "dt"
        }, {
          empty: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "productName",
              header: "Product Name"
            }),
            _createVNode(_component_Column, {
              field: "reference",
              header: "Reference"
            }),
            _createVNode(_component_Column, {
              field: "productQty",
              header: "Current Unit Qty"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(Number(slotProps.data.productQty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "minStockQty",
              header: "Min Stock Require"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(Number(slotProps.data.minStockQty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "name",
              header: "Branch Name"
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}